if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput = this.form.querySelector('[name="id"]');

        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton?.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async syncSelectedVariantAndThickness() {
        const productInfo = this.closest('product-info');
        const variantSelects = productInfo?.querySelector('variant-selects');
        const productUrl = productInfo?.dataset.url;

        if (!productUrl) return;

        let selectedThickness = '';

        const checkedVariantThickness = variantSelects?.querySelector(
          'input[type="radio"]:checked'
        );

        if (checkedVariantThickness?.value?.includes('mm')) {
          selectedThickness = checkedVariantThickness.value.trim();
        }

        const customizerThickness = document.querySelector(
          'input[name="properties[Screen Thickness]"], input[name="properties[Thickness]"]'
        );

        if (!selectedThickness && customizerThickness?.value) {
          selectedThickness = customizerThickness.value.trim();
        }

        if (!selectedThickness) {
          console.error('No selected thickness found');
          return;
        }

        let thicknessProperty = this.form.querySelector(
          'input[name="properties[Thickness]"]'
        );

        if (!thicknessProperty) {
          thicknessProperty = document.createElement('input');
          thicknessProperty.type = 'hidden';
          thicknessProperty.name = 'properties[Thickness]';
          this.form.appendChild(thicknessProperty);
        }

        thicknessProperty.value = selectedThickness;

        try {
          const response = await fetch(`${productUrl}.js`);
          const product = await response.json();

          const matchingVariant = product.variants.find((variant) => {
            return (
              variant.title === selectedThickness ||
              variant.option1 === selectedThickness ||
              variant.option2 === selectedThickness ||
              variant.option3 === selectedThickness ||
              variant.options?.includes(selectedThickness)
            );
          });

          if (!matchingVariant) {
            console.error('No matching variant found for thickness:', selectedThickness);
            return;
          }

          const variantInput = this.form.querySelector('input[name="id"]');

          if (variantInput) {
            variantInput.value = matchingVariant.id;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          console.log('Submitting thickness:', selectedThickness);
          console.log('Submitting variant ID:', matchingVariant.id);
          console.log('Submitting price:', matchingVariant.price);
        } catch (error) {
          console.error('Could not sync variant before add to cart', error);
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        await this.syncSelectedVariantAndThickness();

        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        document
          .querySelectorAll(
            'form[action*="/cart/add"] input[name^="properties["], .tcustomizer-data input[name^="properties["]'
          )
          .forEach((input) => {
            if (input.name && input.value) {
              formData.append(input.name, input.value);
            }
          });

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );

          formData.append('sections_url', window.location.pathname);

          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);

              if (this.submitButtonText) {
                this.submitButtonText.classList.add('hidden');
              }

              soldOutMessage.classList.remove('hidden');

              this.error = true;

              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton?.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton?.removeAttribute('aria-disabled');
            }

            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('aria-disabled', 'true');

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.removeAttribute('disabled');

          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }
      }
    }
  );
}